@let data = section();

<section class="cms-tags tg-section">
    <div class="tg-container cms-tags__grid">
        <div class="cms-tags__intro">
            @if (data.staticBlockContent) {
                <div class="cms-content" [innerHTML]="data.staticBlockContent | trustHtml"></div>
            }
        </div>

        <div class="cms-tags__panel">
            @if (data.tagsBlockContent) {
                <div class="cms-content" [innerHTML]="data.tagsBlockContent | trustHtml"></div>
            }

            @if (data.tagsList.length) {
                <ul class="cms-tags__list" role="group">
                    @for (tag of data.tagsList; track tag.id) {
                        <li class="cms-tags__tag">{{ tag.tagName }}</li>
                    }
                </ul>
            }
        </div>
    </div>
</section>
